import {
  BodyText,
  DialogContent,
  ModalFooter,
  ModalHeader,
  NextDialog,
} from '@cint/wonderment';

export interface LeaveConfirmationDialogProps {
  isOpen: boolean;
  providerName: string;
  onStay: () => void;
  onLeave: () => void;
}

export const LeaveConfirmationDialog = ({
  isOpen,
  providerName,
  onStay,
  onLeave,
}: LeaveConfirmationDialogProps) => {
  return (
    <NextDialog open={isOpen}>
      <DialogContent>
        <ModalHeader title="Leave without finishing?" isDismissible={false} />
        <BodyText>
          If you connect {providerName} later, you&apos;ll need to start the
          authorization process again.
        </BodyText>
        <ModalFooter
          isDanger
          primaryButtonProps={{ text: 'Leave anyway', onClick: onLeave }}
          secondaryButtonProps={{ text: 'Stay and finish', onClick: onStay }}
        />
      </DialogContent>
    </NextDialog>
  );
};
